export enum TimeInterval {
  Week = "week",
  Month = "month",
  Year = "year",
}

export const timeIntervalOptions = [
  { label: "Weekly", value: TimeInterval.Week },
  { label: "Monthly", value: TimeInterval.Month },
  { label: "Yearly", value: TimeInterval.Year },
]
